import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AnalyzerDashboard from "./realtime/AnalyzerDashboard";
import MultimeterDashboard from "./realtime/MultimeterDashboard"
import ReactiveDashboard from "./realtime/ReactiveDashboard"
import GrupArgeDashboard from "./realtime/GrupArgeDashboard";
import VoltampermeDashboard from "./realtime/VoltampermeDashboard";

export default function RealtimePage() {
  const { t } = useTranslation();
  const { deviceId } = useParams();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  // refreshKey: Child componentlere (özellikle grafiklere) verinin zorla yenilenmesi gerektiğini bildiren bir sayaçtır.
  // "Güncelle" butonuna basıldığında bu değer artar ve useEffect bağımlılığı sayesinde grafikler yeniden veri çeker.
  const [refreshKey, setRefreshKey] = useState(0);


  const [data, setData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const deviceModel = localStorage.getItem("deviceModel");
  const deviceType =
    localStorage.getItem("deviceType") || "analyzer"; // analyzer | multimeter | reactive | relay

  const ENDPOINT_PREFIX =
    deviceType === "multimeter"
      ? "/multimeter"
      : deviceType === "gruparge"
        ? "/gruparge"
        : deviceType === "reactive" || deviceType === "relay"
          ? "/reactive"
          : deviceType === "voltampermetre"
            ? "/voltampermetre"
            : "/measurements";

  async function handleForceUpdate() {
    try {
      setIsUpdating(true);
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE}/gateways/force-device/${deviceId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      // cihazdan 5sn arayla 3 kez veri çek
      let count = 0;
      const interval = setInterval(() => {
        fetchRealtime();
        count++;
        if (count >= 3) clearInterval(interval);
      }, 5000);

      // butonu 15s sonra aktifleştir
      setTimeout(() => setIsUpdating(false), 15000);
      setRefreshKey(prev => prev + 1);   // 📌 grafiklere "yenilen" sinyali gönder

    } catch (err) {
      console.error("❌ handleForceUpdate error:", err);
      alert(t('realtime.updateFailed'));
      setIsUpdating(false);
    }
  }

  async function fetchRealtime() {
    try {
      const res = await fetch(
        `${API_BASE}${ENDPOINT_PREFIX}/realtime?deviceId=${deviceId}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const json = await res.json();
      // console.log(json)
      setData(json);

    } catch (err) {
      console.error("❌ fetchRealtime error:", err);
    }
  }

  useEffect(() => {
    fetchRealtime();
    const i = setInterval(fetchRealtime, 5000);
    return () => clearInterval(i);
  }, [deviceId]);

  if (!data)
    return (
      <div className="p-6 text-lg font-semibold text-slate-700">
        {t('realtime.loading')}
      </div>
    );

  return (
    <div className="min-h-screen p-6 space-y-6 bg-slate-100">
      {/* ÜST BAR */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        {/* Sol */}
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-slate-800">
            {t('realtime.title')}
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            {t('realtime.deviceId')}: {deviceId} • {t('realtime.model')}: {deviceModel || "-"} • {t('realtime.type')}:{" "}
            {deviceType}
          </p>
        </div>

        {/* Sağ */}
        {deviceType !== "gruparge" && (
          <button
            onClick={handleForceUpdate}
            disabled={isUpdating}
            className={`w-full sm:w-auto px-4 py-2 rounded-lg font-medium transition border ${isUpdating
              ? "bg-slate-200 border-slate-300 text-slate-500 cursor-not-allowed"
              : "bg-emerald-500 hover:bg-emerald-600 border-emerald-600 text-white shadow-sm"
              }`}
          >
            {isUpdating ? t('realtime.updating') : t('realtime.update')}
          </button>
        )}
      </div>

      {/* CİHAZ TİPİNE GÖRE DASHBOARD SEÇİMİ */}
      {deviceType === "analyzer" && (
        <AnalyzerDashboard
          data={data}
          deviceModel={deviceModel}
          deviceId={deviceId}
          refreshKey={refreshKey}
        />
      )}

      {deviceType === "multimeter" && (
        <MultimeterDashboard
          data={data}
          deviceModel={deviceModel}
          deviceId={deviceId}
          refreshKey={refreshKey}
        />
      )}

      {deviceType === "gruparge" && (
        <GrupArgeDashboard
          data={data}
          deviceModel={deviceModel}
          deviceId={deviceId}
          refreshKey={refreshKey}
        />
      )}

      {deviceType === "reactive" && (
        <ReactiveDashboard
          data={data}
          deviceModel={deviceModel}
          deviceId={deviceId}
          refreshKey={refreshKey}
        />
      )}

      {deviceType === "relay" && (
        <ReactiveDashboard
          data={data}
          deviceModel={deviceModel}
          deviceId={deviceId}
          refreshKey={refreshKey}
        />
      )}

      {deviceType === "voltampermetre" && (
        <VoltampermeDashboard data={data} />
      )}


    </div>
  );
}
